// src/lib/ajustements.js — logique pure des ajustements de facturation.
//
// ⚠️ CHEMIN ARGENT : un ajustement (montant pouvant être NÉGATIF = déduction)
// entre dans le total facturé (facture-html.js somme `ajustements`). Toute
// régression ici fausse une facture émise → logique isolée + testée.
//
// Deux primitives pures, sans effet de bord (le clone `data` et le `saveData`
// restent dans App.jsx) :
//   - canEditAjustements(mk, factEmise) : garde combinée (plancher + facturé).
//   - upsertAjustement(list, aj, uid)   : edit-by-id préservant l'id.

import { canEditMonth } from './resa-invoice-month'

// Garde combinée : un ajustement n'est éditable QUE si le mois est au-dessus du
// plancher de facturation ET qu'aucune facture n'a déjà été émise pour ce
// logement/mois. `canEditMonth` seul ne suffit pas : avril ≥ plancher mais peut
// être déjà facturé → modifier désynchroniserait la facture émise.
// `factEmise` = la facture trouvée (truthy) ou undefined/null si non facturé.
export function canEditAjustements(mk, factEmise) {
  return canEditMonth(mk) && !factEmise
}

// POURQUOI c'est verrouillé, en clair (2026-09-30). Le même message
// « Mois déjà facturé » était servi quand la pièce n'était qu'un BROUILLON :
// rien n'était facturé, et le seul geste utile — supprimer le brouillon —
// n'était pas dit. `estBrouillon` est fourni par l'appelant
// (isDraftInvoice, src/lib/invoices.js — source unique de la règle ; pas
// importé ici pour garder ce module sans dépendance Supabase).
// Retourne null si l'ajustement est modifiable.
export const MSG_AJUST_BROUILLON = "Brouillon en cours : supprime-le pour modifier."
export const MSG_AJUST_FACTURE = "Mois déjà facturé : ajustement verrouillé."
export function motifVerrouAjustements(mk, factEmise, { estBrouillon = false } = {}) {
  if (canEditAjustements(mk, factEmise)) return null
  if (factEmise && estBrouillon) return MSG_AJUST_BROUILLON
  return MSG_AJUST_FACTURE
}

// edit-by-id calqué sur saveExtra : si l'id existe dans la liste → remplace en
// place (préserve l'id, longueur stable) ; sinon push avec un nouvel id.
// `uid` injecté pour testabilité. Retourne une NOUVELLE liste (pas de mutation
// de l'argument).
export function upsertAjustement(list, aj, uid) {
  const arr = Array.isArray(list) ? list.slice() : []
  const idx = aj && aj.id != null ? arr.findIndex(a => a.id === aj.id) : -1
  if (idx >= 0) arr[idx] = { ...aj }
  else arr.push({ ...aj, id: uid() })
  return arr
}
